import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.regexp.split.js";
import User from 'src/store/models/User';
import moment from 'moment';
export default (function (_ref) {
  var app = _ref.app,
      router = _ref.router,
      store = _ref.store,
      Vue = _ref.Vue;
  Vue.mixin({
    data: function data() {
      return {
        isMounted: false
      };
    },
    computed: {
      me: function me() {
        if (!this.$store.state.entities.users.me) {
          User.me();
        }

        return this.$store.state.entities.users.me;
      },
      isSubscribed: function isSubscribed() {
        if (!this.me) return false;
        var expirationDate = !this.me.account.billing_enabled ? moment(this.me.account.expiration).endOf('day') : moment(this.me.account.expiration).add(3, 'days').endOf('day');
        return this.me.account.is_free || expirationDate.isAfter(moment());
      },
      isMobile: function isMobile() {
        return this.$q.screen.lt.sm;
      },
      isSmallScreen: function isSmallScreen() {
        return this.$q.screen.lt.md;
      },
      isMicrosoftTeams: function isMicrosoftTeams() {
        return this.$store.state.app.microsoftTeams.isInitialized;
      },
      isCalendarLoading: function isCalendarLoading() {
        return this.$store.state.app.calendars.googlecalendar.loading || this.$store.state.app.calendars.outlookcalendar.loading;
      },
      visibleRolesOptions: function visibleRolesOptions() {
        if (!this.me) return [];
        var roles = [{
          value: 'member',
          name: this.$tc('roles.description.member', 1),
          caption: this.$t('boot.can_only_see_track_edit')
        }];

        if (this.me.is_admin) {
          roles.push({
            value: 'admin',
            name: this.$t('roles.description.admin'),
            caption: this.$t('boot.can_see_track_edit')
          });
        }

        if (this.me.is_owner) {
          roles.push({
            value: 'owner',
            name: this.$t('roles.description.owner'),
            caption: this.$t('boot.it_is_admin')
          });
        }

        return roles;
      },
      currencySymbol: function currencySymbol() {
        var languageCode = 'en-US';
        var currency = 'USD';

        if (this.me && this.me.settings && this.me.settings.languageCode) {
          languageCode = this.me.settings.languageCode;
        }

        if (this.me && this.me.account) {
          if (this.me.account.settings && this.me.account.settings.currencyCode) {
            currency = this.me.account.settings.currencyCode;
          } else if (this.me.account.settings.currencySymbol) {
            return this.me.account.settings.currencySymbol;
          }
        }

        return new Intl.NumberFormat(languageCode, {
          style: 'currency',
          currency: currency
        }).formatToParts(1).find(function (x) {
          return x.type === 'currency';
        }).value;
      }
    },
    methods: {
      showLoading: function showLoading() {
        this.$q.loading.show();
      },
      hideLoading: function hideLoading() {
        this.$q.loading.hide();
      },
      openChat: function openChat() {
        if (!window.HubSpotConversations.widget.status().loaded) {
          window.HubSpotConversations.widget.load();
        }

        window.HubSpotConversations.widget.open();
      },
      stripTags: function stripTags(html) {
        return html && html.replace(/</gi, '&lt;').replace(/>/gi, '&gt;');
      },
      decodeHtmlEntities: function decodeHtmlEntities(text) {
        var e = document.createElement('textarea');
        e.innerHTML = text; // handle case of empty input

        return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
      },
      getGAClientId: function getGAClientId() {
        return this.$cookies.get('_ga') ? this.$cookies.get('_ga').split('.').slice(2).join('.') : '';
      },
      sendAnalyticsEvent: function sendAnalyticsEvent(eventName) {
        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', eventName, {});

          if (this.$gtag) {
            this.$gtag.event(eventName, process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }
      },
      changeLanguage: function changeLanguage(languageCode) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this._i18n.locale = languageCode || 'en';
                  moment.locale(languageCode || 'en');

                  if (!languageCode) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 5;
                  return import('quasar/lang/' + (languageCode === 'en' ? 'en-us' : languageCode) + '.js').then(function (lang) {
                    _this.$q.lang.set(lang.default);
                  });

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      generateRandomString: function generateRandomString(length) {
        var text = '';
        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (var i = 0; i < length; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
      }
    },
    mounted: function mounted() {
      this.isMounted = true;
    }
  });
});